import { useState } from "react";
import { Button, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AllUsers from "./usersList/AllUsers";
import Customers from "./usersList/Customers";
import Level1FA from "./usersList/Level1FA";
import Level2FA from "./usersList/Level2FA";
import MasterAdmin from "./usersList/MasterAdmin";

const UsersList = () => {
    const navigate = useNavigate();
  const initialTab = "all-users";
  const [activeTab, setActiveTab] = useState(initialTab);
  const handleTabSelect = (key) => {
    setActiveTab(key);
  };
  const handleAddMA = () => {
    console.log("Add Master Admin button clicked");
    navigate("/admin-dashboard/user-management/add-admin");
  };
  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <h1>
        <strong>Users List</strong>
      </h1>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <p>This is the Users List page with User Roles</p>
        <Button variant="primary" onClick={handleAddMA}>
          Add Admin
        </Button>
      </div>

      <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
        <Tabs.Tab eventKey="all-users" title="All Users">
          <AllUsers />
        </Tabs.Tab>
        <Tabs.Tab eventKey="master-admins" title="Master Admins">
          <MasterAdmin />
        </Tabs.Tab>
        <Tabs.Tab eventKey="level1fa" title=" Franchise Admin - 1">
          <Level1FA />
        </Tabs.Tab>
        <Tabs.Tab eventKey="level2fa" title=" Franchise Admin - 2">
          <Level2FA />
        </Tabs.Tab>
        <Tabs.Tab eventKey="customers" title="Customers">
          <Customers />
        </Tabs.Tab>
      </Tabs>
    </div>
  );
};

export default UsersList;
